<template>
  <div :style="{'height': height+'px'}" class="itemPanel">
    <a-collapse :activeKey="activeNames">
      <a-collapse-panel :header="i18n['conventional']" key="0">
        <div class="flex justify-center flex-col">
          <img
            :src="require('../assets/flow/start.svg')"
            data-item="{clazz:'start',size:'30*30',label:''}"
            style="width:42px;height:42px;margin-top:10px"
          />
          <div>{{ i18n['startEvent'] }}</div>
          <img
            :data-item="userTaskData"
            :src="require('../assets/flow/user-task.svg')"
            style="width:80px;height:44px;margin-top:10px"
          />
          <div>{{ i18n['userTask'] }}</div>
          <img
            :data-item="handleNodeData"
            :src="require('../assets/flow/receive-task.svg')"
            style="width:80px;height:44px;margin-top:10px"
          />
          <div>{{ i18n['handleNode'] }}</div>
          <!-- <img :data-item="scriptTaskData"
                     :src="require('../assets/flow/script-task.svg')" style="width:80px;height:44px;margin-top:10px" />
          <div>{{i18n['scriptTask']}}</div>-->
          <img
            :src="require('../assets/flow/end.svg')"
            data-item="{clazz:'end',size:'30*30',label:''}"
            style="width:42px;height:42px;margin-top:10px"
          />
          <div>{{ i18n['endEvent'] }}</div>
        </div>
      </a-collapse-panel>
      <a-collapse-panel :header="i18n['gateway']" key="1">
        <div class="flex justify-center flex-col">
          <img
            :src="require('../assets/flow/exclusive-gateway.svg')"
            data-item="{clazz:'exclusiveGateway',size:'40*40',label:''}"
            style="width:48px;height:48px;margin-top:10px"
          />
          <div>{{ i18n['exclusiveGateway'] }}</div>
          <img
            :src="require('../assets/flow/parallel-gateway.svg')"
            data-item="{clazz:'parallelGateway',size:'40*40',label:''}"
            style="width:48px;height:48px;margin-top:10px"
          />
          <div>{{ i18n['parallelGateway'] }}</div>
        </div>
        <!-- <img data-item="{clazz:'inclusiveGateway',size:'40*40',label:''}"
                     :src="require('../assets/flow/inclusive-gateway.svg')" style="width:48px;height:48px;margin-top:10px" />
        <div>{{i18n['inclusiveGateway']}}</div>-->
      </a-collapse-panel>
    </a-collapse>
  </div>
</template>
<script>
  export default {
    inject: ['i18n'],
    props: {
      height: {
        type: Number,
        default: 800
      }
    },

    data () {
      return {
        activeNames: ['0', '1'],
        userTaskData: "{clazz:'userTask',size:'80*44',label:'" + this.i18n['userTask'] + "'}",
        // scriptTaskData: "{clazz:'scriptTask',size:'80*44',label:'" + this.i18n['scriptTask'] + "'}",
        javaTaskData: "{clazz:'javaTask',size:'80*44',label:'" + this.i18n['javaTask'] + "'}",
        mailTaskData: "{clazz:'mailTask',size:'80*44',label:'" + this.i18n['mailTask'] + "'}",
        handleNodeData: "{clazz:'receiveTask',size:'80*44',label:'" + this.i18n['handleNode'] + "'}"
      }
    }
  }
</script>

<style lang="scss" scoped>

  .itemPanel {
    float: left;
    width: 10%;
    background: #f0f2f5;
    overflow-y: auto;
    border-left: 1px solid #e9e9e9;
    border-bottom: 1px solid #e9e9e9;

    img {
      width: 92px;
      height: 96px;
      padding: 4px;
      border: 1px solid rgba(0, 0, 0, 0);
      border-radius: 2px;
      align-self: center;
      &:hover {
        border: 1px solid #ccc;
        cursor: move;
      }
    }
    div {
      align-self: center;
    }
  }

</style>
